module.exports = __webpack_public_path__ + "img/photozone-2.ccfb876e.webp";